import { omit } from 'lodash';
import { StateCreator } from 'zustand';

import { TQuoteStore } from '@store/types/GlobalStore.type';
import { UnsavedChangesSlice, UnsavedFormAttribute } from '@store/types/UnsavedChangesSlice.type';

const initialState = {
  attributesById: {},
  unsavedFormAttributes: {} as Record<string, UnsavedFormAttribute>,
  formsV2SaveFn: null as (() => Promise<boolean>) | null,
};

export const createUnsavedChangesSlice: StateCreator<TQuoteStore, [], [], UnsavedChangesSlice> = (set, get) => ({
  ...initialState,
  setAttributeValue: (attributeId, update) => {
    get().setAttributeValues([
      {
        attributeId,
        update,
      },
    ]);
  },
  setAttributeValues: (updates) => {
    set((state) => {
      return {
        ...state,
        attributesById: {
          ...state.attributesById,
          ...Object.fromEntries(
            updates.map(({ attributeId, update }) => [
              attributeId,
              { ...state.attributesById[attributeId], ...update },
            ]),
          ),
        },
      };
    });
  },
  clearAttributeValues: (attributeIds) =>
    set((state) => ({
      ...state,
      attributesById: omit(state.attributesById, attributeIds),
    })),
  resetStore: () => set(initialState),

  // Forms V2: unsaved form attribute actions
  setFormAttributeValue: (key, update) => {
    set((state) => ({
      ...state,
      unsavedFormAttributes: { ...state.unsavedFormAttributes, [key]: update },
    }));
    get().triggerFormValidation();
  },
  removeFormAttributeValues: (keys) => {
    set((state) => {
      const next = { ...state.unsavedFormAttributes };
      keys.forEach((k) => delete next[k]);
      return { ...state, unsavedFormAttributes: next };
    });
    get().triggerFormValidation();
  },
  clearFormAttributes: () => {
    set((state) => ({ ...state, unsavedFormAttributes: {} }));
  },

  setFormsV2SaveFn: (saveFn) => set({ formsV2SaveFn: saveFn }),
});
